import React, { useState } from 'react';
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom';
import home from './home/App14';
import breakingbad from './breakingbad/App1';
import expenser from './expenser/App2';
import covid from './covid/App3';
import weather from './weather/App4';
import pixabay from './pixabay/App5';
import recipe from './recipe/App6';
import googleMap from './googleMap/App7';
import voiceCommand from './voiceCommand/App8';
import coins from './coins/_App9';
import tictactoe from './tictactoe/App10';
import movieSearch from './movieSearch/App11';
import movieSearchWatchList from './movieSearch/components/Watchlist';
import movieSearchAdd from './movieSearch/components/Add';
import movieSearchWatched from './movieSearch/components/Watched';
//import taskmanager from './taskmanager/App12';
import NotFound from './404/App13';
import qiita from './qiita/App16';
import blog from './blog/App17';
import { WatchListContextProvider } from './coins/context/watchListContext';
import { GlobalProvider } from './movieSearch/context/GlobalState';
import coinDetailPage from './coins/pages/CoinDetailPage';
import coinSummaryPage from './coins/pages/CoinSummaryPage';
import onlineShop from './onlineShop/App18';
import { BookProvider } from './onlineShop/context/books';
import { CartProvider } from './onlineShop/context/cart';
// import bookDetails from './onlineShop/pages/BookDetails';
// import books from './onlineShop/pages/Books';
// import cart from './onlineShop/pages/Cart';
// import checkout from './onlineShop/pages/Checkout';
// import admin from './onlineShop/pages/Admin';
import leaflet from './leaflet/App';
import encard from './encard/App'
import securityPlus from './securityPlus/App'

const App = () => {
	return (
		<GlobalProvider>
			<WatchListContextProvider>
				<BrowserRouter>
					<CartProvider>
						<BookProvider>
							<Switch>
								<Route exact path="/" component={home} />
								<Route exact path="/breakingbad" component={breakingbad} />
								<Route exact path="/expenser" component={expenser} />
								<Route exact path="/covid" component={covid} />
								<Route exact path="/weather" component={weather} />
								<Route exact path="/pixabay" component={pixabay} />
								<Route exact path="/recipe" component={recipe} />
								<Route exact path="/google_map" component={googleMap} />
								<Route exact path="/voice_command" component={voiceCommand} />
								<Route exact path="/coins" component={coinSummaryPage} />
								<Route path="/coins/:id" component={coinDetailPage} />
								<Route exact path="/tictactoe" component={tictactoe} />
								<Route exact path="/movieSearch" component={movieSearch} />
								<Route exact path="/movieSearch/watchList" component={movieSearchWatchList} />
								<Route exact path="/movieSearch/add" component={movieSearchAdd} />
								<Route exact path="/movieSearch/watched" component={movieSearchWatched} />
								{/* <Route exact path="/taskmanager" component={taskmanager} /> */}
								<Route exact path="/qiita" component={qiita} />
								<Route exact path="/blog" component={blog} />
								{/* <Route exact path="/onlineShop" component={onlineShop} />
								<Route exact path="/onlineShop/books" component={books} />
								<Route exact path="/onlineShop/books/:id" component={bookDetails} />
								<Route exact path="/onlineShop/cart/" component={cart} />
								<Route exact path="/onlineShop/checkout/" component={checkout} />
								<Route exact path="/onlineShop/admin/" component={admin} /> */}
								<Route exact path="/leaflet" component={leaflet} />
								<Route exact path="/encard" component={encard} />
								<Route exact path="/securityPlus" component={securityPlus} />
								<Route component={NotFound} />
							</Switch>
						</BookProvider>
					</CartProvider>
				</BrowserRouter>
			</WatchListContextProvider>
		</GlobalProvider>
	);
};

export default App;
